import { CORE, DISK, RAM } from 'components/vm-deployment/constants';
import * as Yup from 'yup';

export const slidersValidate = {
  [DISK]: Yup.string().required('vs/instance/custom_create.step1_string6'),
  [RAM]: Yup.string().required('vs/instance/custom_create.step1_string7'),
  [CORE]: Yup.string().required('vs/instance/custom_create.step1_string8'),
};
